// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide[data-v-1fa7cd5a]{width:50%!important}@media (min-width:1024px){.swiper-slide[data-v-1fa7cd5a]{width:16.666667%!important}}.swiper-slide[data-v-1fa7cd5a]{margin-right:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
